import { AnchorHTMLAttributes, ReactNode } from 'react'

interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
  className?: string
  linkType?: 'external' | 'internal'
  children?: ReactNode
}
export const LinkComponent = (props: Props) => {
  const { children, linkType = 'external' } = props

  const renderExternalLink = () => (
    <a {...props} target='_blank' rel='noopener noreferrer'>
      {children}
    </a>
  )

  const renderLink = () => {
    if (linkType === 'external') {
      return renderExternalLink()
    }
    return <a {...props}>{children}</a>
  }

  return renderLink()
}
